import { buildBrandScopedPath } from "./brand-navigation";

export type RunView = "result" | "trace";

/**
 * Keeps the brand and the one supported workspace-return hint when switching
 * between the sibling Result and Trace views of one Run.
 */
export function buildRunViewPath(
  runId: string,
  view: RunView,
  brandId: string | null | undefined,
  search = "",
): string {
  const suffix = view === "trace" ? "/trace" : "";
  const base = buildBrandScopedPath(`/runs/${encodeURIComponent(runId)}${suffix}`, brandId);
  const [pathname = base, baseSearch = ""] = base.split("?");
  const params = new URLSearchParams(baseSearch);
  const returnTo = new URLSearchParams(search).get("return_to");
  if (returnTo) params.set("return_to", returnTo);
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
}
